import { render, staticRenderFns } from "./AvisAddUpdate.vue?vue&type=template&id=1ffe70c4&"
import script from "./AvisAddUpdate.vue?vue&type=script&lang=js&"
export * from "./AvisAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AvisAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports